import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PAZIENTI, SEDE } from 'configs/AppConfig'
import StrapiService from "../../services/StrapiService";
import moment from "moment";
import { errorMessage } from "../../utils/messages";
import { PAZIENTI_ERROR, PAZIENTI_LOADED, PAZIENTI_MAP_VALUE, PAZIENTI_VALUE } from "../../constants/AuthConstant";
import { setCompressedJsonItem } from '../../utils/compressedStorage';
import PazientiService from "../../services/PazientiService";
import { summarizePatientAppointments as trovaProssimoAppuntamento } from '../../utils/patientHistory';
import { buildLegacyPatientListUrl, normalizeLegacyPatientListEntries, normalizePatientListResponse, patientListNeedsFullHistory } from '../../utils/patientList';

export const initialState = PAZIENTI


// Funzione per ottenere una lista unica di studi di riferimento per ID
function getUniqueStudiosById(data) {
    const groupedById = {};

    // Raggruppa gli elementi per ID
    data.forEach(entry => {
        if (!groupedById[entry.id]) {
            groupedById[entry.id] = { ...entry };
            groupedById[entry.id].studio_di_riferimento = [];
        }
        groupedById[entry.id].studio_di_riferimento.push(entry.studio_di_riferimento);
    });

    // Crea un array con gli oggetti raggruppati per ID e studi di riferimento unici
    const result = Object.values(groupedById).map(entry => ({
        ...entry,
        studio_di_riferimento: [...new Set(entry.studio_di_riferimento)]
    }));

    return result;
}


export const loadPazienti = createAsyncThunk('carica-pazienti', async (data, { rejectWithValue, getState }) => {
    console.log("[loadPazienti]");

    try {
        const bindingRoles = getState().auth.binding_roles;
        if (!Array.isArray(bindingRoles)) throw new TypeError('Invalid patient binding roles');
        const roles = bindingRoles.map(role => role.id);
        let result = [];
        if (roles.length !== 0) {
            const asOf = new Date().toISOString();
            const response = await PazientiService.getListaPazienti(roles, asOf);
            if (patientListNeedsFullHistory(response, asOf)) {
                const fullResponse = await StrapiService.get(buildLegacyPatientListUrl(roles));
                result = getUniqueStudiosById(normalizeLegacyPatientListEntries(fullResponse));
            } else {
                result = normalizePatientListResponse(response);
            }
        }

        localStorage.setItem(PAZIENTI_VALUE, JSON.stringify(result))
        // console.table(result)
        return result

    } catch (err) {
        console.error("err", err)
        let message = (
            <div>
                Qualcosa è andato storto nel recuperare i pazienti. Riprovare!
                <br />
                Se il problema persiste, contattare l' assistenza.
            </div>
        );

        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
}, {
    // Startup and manual refresh can overlap; keep the active request intact.
    condition: (_, {getState}) => !getState().pazienti?.loadingPazienti,
})


export const deletePaziente = createAsyncThunk('cancella-paziente', async (id, { rejectWithValue, getState }) => {
    console.log("[deletePaziente]");
    try {
        let currentState = getState().pazienti.pazienti.map((item) => ({
            ...item,
        }))
        await PazientiService.deletePatient(id);
        const indexobj = currentState.findIndex((element) => element.id === id);
        currentState.splice(indexobj, 1)
        return currentState
    } catch (err) {
        console.error("err", err)
        let message = (
            <div>
                Qualcosa è andato storto nel cancellare il paziente. Riprovare!
                <br />
                Se il problema persiste, contattare l' assistenza.
            </div>
        );

        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
})

export const editPatient = createAsyncThunk('modifica-paziente', async (input, { rejectWithValue, getState }) => {
    try {
        console.log("[editPatient]", input.id)
        const id = input.id
        let currentState = getState().pazienti.pazienti.map((item) => ({
            ...item,
        }))

        const indexobj = currentState.findIndex((element) => element.id === id);

        const patient = input.updatedFields.attributes


        const state_type_patients = patient?.state_type_patients;

        let stato = (state_type_patients == null || state_type_patients == undefined) ? [] : state_type_patients.data.map(item => {
            const { documentId, attributes } = item;
            const { stato, tipo, sede, anno_di_vendita } = attributes;

            const stato_paziente = stato?.split(",") ? stato.split(",").sort() : []
            const anno_di_vendita_paziente = anno_di_vendita?.split(",") && anno_di_vendita!=="" ? anno_di_vendita.split(",").map(Number).sort(function (a, b) {
                return a - b;
            }) : []

            return {
                id: documentId,
                tipo_paziente: tipo,
                stato_paziente: stato_paziente,
                anno_di_vendita: anno_di_vendita_paziente,
                sede,
            };
        });
        console.log("456 stato", stato)
        const appuntamenti = trovaProssimoAppuntamento(patient.cronologia)
        let updatedPatient = {
            id: id,
            id_maffle: patient.id_maffle,
            nome: patient.nome,
            cognome: patient.cognome,
            data_di_nascita: patient.data_di_nascita == null ? "N.D" : moment(patient.data_di_nascita).format("DD-MM-YYYY"),
            citta: patient.citta == null ? "N.D" : patient.citta,
            citta_di_residenza: patient.citta_di_residenza == null ? "N.D" : patient.citta_di_residenza,
            tipo_provenienza: patient.tipo_provenienza,
            nome_provenienza: patient.nome_provenienza,

            provenienza: patient.tipo_provenienza + " " + patient.nome_provenienza,
            cellulare: patient.cellulare,
            studio_di_riferimento: patient.stores.data.map((store) => store.attributes.name),
            ultimo_appuntamento: appuntamenti.prossimoAppuntamento,
            ultimo_appuntamento_effettuato: appuntamenti.ultimoAppuntamento,
            ultimo_appuntamento_mancato: appuntamenti.ultimoAppuntamentoMancato,
            stato: stato
            // tipo_paziente: patient.tipo_paziente,
            // stato_paziente: patient.stato_paziente?.split(",") ? patient.stato_paziente.split(",").sort() : [],
            // anno_di_vendita: patient.anno_di_vendita?.split(",") ? patient.anno_di_vendita.split(",").map(Number).sort(function (a, b) {
            //     return a - b;
            // }) : []
        }

        currentState[indexobj] = updatedPatient
        localStorage.setItem(PAZIENTI_VALUE, JSON.stringify(currentState))
        return currentState
    } catch (err) {
        console.error("err", err)
        let message = (
            <div>
                Non è stato possibile modificare l'evento.
                <br />
                Se il problema persiste, contattare l' assistenza.
            </div>
        );

        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
});

export const addNewPatient = createAsyncThunk('aggiungi-paziente', async ({ formData, id, id_maffle }, {
    rejectWithValue,
    getState
}) => {
    try {
        const currentState = getState().pazienti.pazienti;
        localStorage.setItem(PAZIENTI_VALUE, JSON.stringify([...currentState, ...[setAddPatient(formData, id, id_maffle)]]))
        return [...currentState, ...[setAddPatient(formData, id, id_maffle)]];
    } catch (err) {
        console.error("err", err)
        let message = (
            <div>
                Non è stato possibile aggiungere il paziente.
                <br />
                Se il problema persiste, contattare l' assistenza.
            </div>
        );

        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
});
export const editProssimoApputamento = createAsyncThunk('modifica-paziente-prossimo-apputamento', async (input, { rejectWithValue, getState }) => {
    try {
        const id = input.id
        const cronologia = input.cronologia
        let currentState = getState().pazienti.pazienti.map((item) => ({
            ...item,
        }))
        const indexobj = currentState.findIndex((element) => element.id === id);
        const patient = currentState[indexobj]
        console.log("ale-debug-aggiornamento cronologia",cronologia)
        const appuntamenti = trovaProssimoAppuntamento(cronologia)
        let updatedPatient = {
            ...patient,
            ultimo_appuntamento: appuntamenti.prossimoAppuntamento,
            ultimo_appuntamento_effettuato: appuntamenti.ultimoAppuntamento,
            ultimo_appuntamento_mancato: appuntamenti.ultimoAppuntamentoMancato,
        }

        currentState[indexobj] = updatedPatient
        localStorage.setItem(PAZIENTI_VALUE, JSON.stringify(currentState))
        return currentState
    } catch (err) {
        console.error("err", err)
        let message = (
            <div>
                Non è stato possibile modificare l'evento.
                <br />
                Se il problema persiste, contattare l' assistenza.
            </div>
        );

        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
});
const setAddPatient = (patient, id, id_maffle) => {
    console.log("ADD NEW PATIENT patient", patient)
    console.log("ADD NEW PATIENT id", id)

    return {
        id: id,
        nome: patient.nome,
        id_maffle: id_maffle,
        cognome: patient.cognome,
        data_di_nascita: patient.data_di_nascita == null ? "N.D" : moment(patient.data_di_nascita).format("DD-MM-YYYY"),
        citta: patient.citta == null ? "N.D" : patient.citta,
        citta_di_residenza: patient.citta_di_residenza == null ? "N.D" : patient.citta_di_residenza,
        tipo_provenienza: patient.tipo_provenienza,
        nome_provenienza: patient.nome_provenienza,
        provenienza: patient.tipo_provenienza + " " + patient.nome_provenienza,
        cellulare: patient.cellulare,
        studio_di_riferimento: patient.studio_di_riferimento.split(","),
        ultimo_appuntamento: "N.D",
        stato: [],
        // stato_paziente: [],
        // anno_di_vendita: [],
    }
}

export const pazientiSlice = createSlice({
    name: 'pazienti', initialState, reducers: {
        pazientiLoaded: (state, action) => {
            //console.log("state", state)
            state.loading = false
            state.pazienti = action.payload;
        },
        showLoading: (state) => {
            state.loading = true
        },
        updatePaziente: (state, action) => {
            const { id, updatedFields } = action.payload;
            state.pazienti = state.pazienti.map((paziente) => {
                if (paziente.id == id) {
                    const campiDaAggiornare = {};
                    for (const campo in updatedFields) {
                        if (campo in paziente) {
                            // questo if è importante, serve per modificare solo le chiavi del json che fanno parte della listaPazienti del redux!
                            if (updatedFields[campo] != null) {
                                if (campo !== "data_di_nascita") {
                                    campiDaAggiornare[campo] = updatedFields[campo];
                                } else {
                                    campiDaAggiornare[campo] = moment(updatedFields[campo]).format("DD-MM-YYYY");
                                }
                            } else {
                                campiDaAggiornare[campo] = "N.D";
                            }
                        }
                    }

                    return {
                        ...paziente,
                        ...campiDaAggiornare, // Combina i campi esistenti con i campi aggiornati
                    };
                }
                return paziente;
            });
        },
    }, extraReducers: (builder) => {
        builder
            .addCase(loadPazienti.pending, (state) => {
                state.loadingPazienti = true
                state.loadedPazienti = false
                state.errorPazienti = false
            })
            .addCase(loadPazienti.fulfilled, (state, action) => {
                state.loadingPazienti = false
                state.pazienti = action.payload

                localStorage.setItem(PAZIENTI_LOADED, true)
                localStorage.setItem(PAZIENTI_ERROR, false)
                const pazientiMap = action.payload.reduce((acc, patient) => {
                    acc[patient.id_maffle] = patient;
                    return acc;
                }, {});
                state.pazientiMap = pazientiMap
                setCompressedJsonItem(PAZIENTI_MAP_VALUE, pazientiMap)

                state.loadedPazienti = true
                state.errorPazienti = false
            })
            .addCase(loadPazienti.rejected, (state, action) => {
                state.loadingPazienti = false
                state.pazienti = []
                state.pazientiMap = {}

                localStorage.setItem(PAZIENTI_LOADED, false)
                localStorage.setItem(PAZIENTI_ERROR, true)
                localStorage.removeItem(PAZIENTI_VALUE)
                localStorage.removeItem(PAZIENTI_MAP_VALUE)
                state.loadedPazienti = false
                state.errorPazienti = true
            })
            .addCase(deletePaziente.pending, (state) => {
                state.loadingDeletePazienti = true
                state.loadedDeletePazienti = false
                state.errorDeletePazienti = false
            })
            .addCase(deletePaziente.fulfilled, (state, action) => {
                state.loadingDeletePazienti = false
                state.pazienti = action.payload
                localStorage.setItem(PAZIENTI_VALUE, JSON.stringify(action.payload))

                const pazientiMap = action.payload.reduce((acc, patient) => {
                    acc[patient.id_maffle] = patient;
                    return acc;
                }, {});
                state.pazientiMap = pazientiMap
                setCompressedJsonItem(PAZIENTI_MAP_VALUE, pazientiMap)

                state.loadedDeletePazienti = true
                state.errorDeletePazienti = false
            })
            .addCase(deletePaziente.rejected, (state, action) => {
                state.loadingDeletePazienti = false
                state.loadedDeletePazienti = true
                state.errorDeletePazienti = false
            })
            .addCase(editPatient.fulfilled, (state, action) => {
                state.pazienti = action.payload
                const pazientiMap = action.payload.reduce((acc, patient) => {
                    acc[patient.id_maffle] = patient;
                    return acc;
                }, {});
                state.pazientiMap = pazientiMap
                setCompressedJsonItem(PAZIENTI_MAP_VALUE, pazientiMap)
            })
            .addCase(editProssimoApputamento.fulfilled, (state, action) => {
                state.pazienti = action.payload
                const pazientiMap = action.payload.reduce((acc, patient) => {
                    acc[patient.id_maffle] = patient;
                    return acc;
                }, {});
                state.pazientiMap = pazientiMap
                setCompressedJsonItem(PAZIENTI_MAP_VALUE, pazientiMap)
            })
            .addCase(addNewPatient.fulfilled, (state, action) => {
                state.pazienti = action.payload
                const pazientiMap = action.payload.reduce((acc, patient) => {
                    acc[patient.id_maffle] = patient;
                    return acc;
                }, {});
                state.pazientiMap = pazientiMap
                setCompressedJsonItem(PAZIENTI_MAP_VALUE, pazientiMap)
            })

    }
})

export const {
    updatePaziente,
} = pazientiSlice.actions

export default pazientiSlice.reducer;

